import { useEffect, useMemo, useRef } from "react";
import { useGLTF, useAnimations } from "@react-three/drei";
import * as THREE from "three";
import { SkeletonUtils } from "three-stdlib";

export default function CubeModel({
  position = [15.8, -0.11, 25.7],
  rotation = [0, 0, 0],
  scale = 1,
  ...props
}) {
  const group = useRef();
  const { scene, animations } = useGLTF("/cube.glb");
  const clonedScene = useMemo(() => SkeletonUtils.clone(scene), [scene]);
  const { actions } = useAnimations(animations, group);

  useEffect(() => {
    clonedScene.traverse((child) => {
      if (child.isMesh || child.isSkinnedMesh) {
        child.castShadow = true;
        child.receiveShadow = true;
      }
    });
  }, [clonedScene]);

  useEffect(() => {
    if (!actions) return undefined;

    const actionList = Object.values(actions).filter(Boolean);
    actionList.forEach((action) => {
      action.reset().setLoop(THREE.LoopRepeat, Infinity).play();
      action.clampWhenFinished = false;
    });

    return () => {
      actionList.forEach((action) => {
        action.stop();
      });
    };
  }, [actions]);

  useEffect(() => {
    if (!group.current) return;
    group.current.rotation.set(rotation[0], rotation[1], rotation[2]);
  }, [rotation]);

  return (
    <group ref={group} position={position} rotation={rotation} scale={scale} {...props}>
      <primitive object={clonedScene} />
    </group>
  );
}

useGLTF.preload("/cube.glb");
